import ca from '../../di/cian_analytics';

export const trackChangeSkin = (newSkin: string, oldSkin: string): void => {
  ca('event', {
    name: 'oldevent',
    category: 'Skin',
    action: newSkin,
    label: oldSkin,
  });
};

export function sendSubscriptionForm(type: 'long' | 'short') {
  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Send',
    label: `From_cat_${type}`,
  });
}

export const showHitLinks = (pagination: boolean): void => {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'view_alsoLooking',
    label: pagination ? 'withPagination' : 'withoutPagination',
  });
};

export const clickOnHitLink = (pagination: boolean): void => {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click_alsoLooking',
    label: pagination ? 'withPagination' : 'withoutPagination',
  });
};



// WEBPACK FOOTER //
// ./src/bundles/serp/tracking.ts